export enum DeliveryType {
	DeliveryToAddress = "DeliveryToAddress",
	DeliveryToParcelShop = "DeliveryToParcelShop",
	DeliveryToParcelBox = "DeliveryToParcelBox",
	PersonalPickup = "PersonalPickup",
	Email = "Email",
}
